import classNames from "classnames";
import { useCarContext } from "./context";
import { useMemo } from "react";

const Card = ({ isUnique, ...props }) => {
  const {
    mark,
    model,
    year,
    price,
    additional,
    mileage,
    location,
    extra,
    phone,
    image,
  } = props;

  const { setSelectedCar } = useCarContext();

  const title = useMemo(() => `${mark} ${model} ${year}`, [mark, model, year]);

  return (
    <div
      className={classNames("card", {
        "card--is-unique": isUnique,
      })}
    >
      <div className="card-image">
        <figure className="image is-4by3">
          <img src={image} alt={title} />
        </figure>
      </div>
      <div className="card-content">
        <div className="media">
          <div className="media-content">
            <p className="title is-6">{title}</p>
          </div>
        </div>
        <div className="content">
          <p className="price is-bold">{price}</p>
          <br />
          <p className="price is-small">{additional}</p>
          <div className="level" style={{ marginBottom: 10 }}>
            <div className="level-left">
              <div className="level-item">
                <p className="miles">{mileage}</p>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <span className="tag is-success">Good deal</span>
              </div>
            </div>
          </div>
          <div className="level" style={{ marginBottom: 0 }}>
            <div className="level-left">
              <div className="level-item">
                <p className="miles">{location}</p>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <span className="price is-small">{extra}</span>
              </div>
            </div>
          </div>
          <a href={`tel:${phone}`}>{phone}</a>
        </div>
      </div>
      <div className="card-footer">
        <a
          href="#request-info"
          className="card-footer-item"
          onClick={(e) => {
            e.preventDefault();
            setSelectedCar({ ...props });
          }}
        >
          Request info
        </a>
      </div>
    </div>
  );
};

export default Card;
